import $i from "~/i18n";

export const getData = async context  => {
  try {
    let data = await axios.get('/contact-us/all')
    if (data.state != 200) return
    
    // context.commit('setBio', data.bio[0])
    // console.log(data);
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/calls/actions.js